import { Component, Input } from '@angular/core';
import { CONSTANTS } from '../../app.constants';

@Component({
	selector: 'app-order-priority-badge',
	templateUrl: './order-priority-badge.component.html',
	styleUrls: ['./order-priority-badge.component.scss'],
})
export class OrderPriorityBadgeComponent {
	@Input() priority: number;

	get isRush(): boolean {
		return this.priority == CONSTANTS.orderPriority.rush || this.priority == CONSTANTS.orderPriority.rushAndPriority;
	}

	get isPriority(): boolean {
		return this.priority == CONSTANTS.orderPriority.priority || this.priority == CONSTANTS.orderPriority.rushAndPriority;
	}
}
